import React from "react";
import {Link} from "react-router-dom";
import classNames from "classnames";

import ReactTable from "react-table";
import ClipLoader from 'react-spinners/ClipLoader';
import moment from "moment";
import {Card, CardContent} from "@material-ui/core";
import {Button} from "reactstrap";

import API from "@beardeddevops/react.api";
import APPCONFIG from "../../constants/Config";
import Framework from "@beardeddevops/react.framework";
import Types from 'constants/Types';
import {Objects} from "components";

function parseExpectedFromNote(note) {
	if (!note) {
		return null;
	}
	const match = note.match(/Expected \$([0-9]+\.?[0-9]*)/);
	if (!match) {
		return null;
	}
	const expected = parseFloat(match[1]);
	return Number.isNaN(expected) ? null : expected;
}

function ledgerExpectedAfter(row) {
	if (row.expected_amount != null && row.expected_amount !== '') {
		const expected = parseFloat(row.expected_amount);
		if (!Number.isNaN(expected)) {
			return expected;
		}
	}
	if (
		(row.event === 'Start of Day' || row.event === 'End of Day')
		&& row.cash_left_in_drawer != null
		&& row.cash_left_in_drawer !== ''
	) {
		const cashLeft = parseFloat(row.cash_left_in_drawer);
		if (!Number.isNaN(cashLeft)) {
			return cashLeft;
		}
	}
	if (row.event === 'Count' && row.counted_amount != null && row.counted_amount !== '') {
		const counted = parseFloat(row.counted_amount);
		if (!Number.isNaN(counted)) {
			return counted;
		}
	}
	return parseExpectedFromNote(row.note);
}

function parseCashDepositFromNote(note) {
	if (!note) {
		return null;
	}
	const match = note.match(/Deposit \$([0-9]+\.?[0-9]*)/);
	if (!match) {
		return null;
	}
	const value = parseFloat(match[1]);
	return Number.isNaN(value) ? null : value;
}

function ledgerCashDeposit(row) {
	if (row.cash_deposit != null && row.cash_deposit !== '') {
		const value = parseFloat(row.cash_deposit);
		if (!Number.isNaN(value) && value > 0.005) {
			return value;
		}
	}
	if (row.event === 'End of Day') {
		return parseCashDepositFromNote(row.note);
	}
	return null;
}

function ledgerUserNote(note, event) {
	if (!note) {
		return '-';
	}
	const sep = ' | ';
	const idx = note.indexOf(sep);
	if (idx >= 0) {
		const user = note.substring(idx + sep.length).trim();
		return user || '-';
	}
	if (event === 'Start of Day' || event === 'End of Day' || event === 'Count') {
		return '-';
	}
	return note;
}

class RegisterLedgers extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Registers_Ledgers._name, API.RequestType.READ_ALL);
		model.parent = props.parent;
		super(props, model);
		this.state.limit = 14;
		this.limit = 14;
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.reloadSelf !== this.props.reloadSelf
			|| prevProps.parent !== this.props.parent
		) {
			if (typeof this.fetchData === "function") {
				this.fetchData();
			}
		}
	}

	canEditLedgerNote = (row) => {
		const rs = this.props.rootState || {};
		if (rs.isAdmin || rs.user == null) {
			return true;
		}
		return row.creator != null && row.creator === rs.user;
	}

	openEditLedger = (row) => {
		this.setState({
			editLedgerId: row.pkey,
			editCanSave: this.canEditLedgerNote(row),
		});
	}

	closeEditLedger = () => {
		this.setState({editLedgerId: null, editCanSave: false});
	}

	handleEditAfterSave = () => {
		this.closeEditLedger();
		if (typeof this.fetchData === "function") {
			this.fetchData();
		}
	}

	render() {
		const {data, pages, loading, limit} = this.state;
		let columns = [
			{
				Header: "Date",
				id: "created",
				className: 'center-column',
				accessor: d => {
					return moment(d.created)
						.local()
						.format("MM/DD/YYYY hh:mm A")
				}
			},
			{
				Header: "Event",
				id: "event",
				accessor: r => r.event || r.note || "",
			},
			{
				Header: "Amount Changed",
				accessor: "amount",
				className: 'right-column',
				Cell: props => <span>$ {props.value}</span>
			},
			{
				Header: "Expected",
				id: "expected_amount",
				className: 'right-column',
				accessor: r => {
					const value = ledgerExpectedAfter(r);
					return value != null ? "$ " + value.toFixed(2) : "-";
				},
				sortable: false
			},
			{
				Header: "Cash Deposit",
				id: "cash_deposit",
				accessor: r => {
					const value = ledgerCashDeposit(r);
					return value != null ? "$ " + value.toFixed(2) : "-";
				},
				sortable: false,
				width: 120,
			},
			{
				Header: "User",
				id: "user",
				className: 'center-column',
				/** @var r.users */
				accessor: r => r.users != null ? (r.users.name_first + " " + r.users.name_last) : this.props.rootState.account_name,
				Cell: props => props.original.users != null ?
					<Link to={"/users/" + props.original.users.pkey}>{props.value}</Link> :
					<Link to={"/settings"}>{this.props.rootState.account_name}</Link>
			},
			{
				Header: "Note",
				id: "note",
				accessor: r => ledgerUserNote(r.note, r.event),
				width: 500
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => (
					<Button
						color="green-meadow"
						size="sm"
						block
						onClick={() => this.openEditLedger(props.original)}
						style={{ marginTop: '6px' }}
					>
						<i className="fa fa-pencil"/>
					</Button>
				)
			},
		]
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Ledgers')}
							{this.renderDateRangeSearch()}
							{this.renderHeaderRight("Ledger", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual
						data={data}
						pages={pages}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={this.fetchData}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						onPageSizeChange={this.onPageSizeChange}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						minRows={0}
					/>
					{APPCONFIG.settings.isDev() ? null :
						<div className={classNames("tabled", "loader", {'active': loading})}>
							<ClipLoader color={"#4A4A4A"} loading={loading}/>
						</div>}
					<Framework.Elements.UniversalModal
						parent={this.props.parent}
						id={this.state.editLedgerId}
						isDev={APPCONFIG.settings.isDev()}
						title="Ledger Entry"
						name="Ledger"
						submitLabel={this.state.editCanSave ? "Save Note" : undefined}
						object={Objects.RegisterLedger}
						objectProps={{
							editMode: true,
							canEditNote: this.state.editCanSave,
							retainedFloat: this.props.rootState?.retained_float,
						}}
						history={this.props.history}
						toggle={!!this.state.editLedgerId}
						reportClose={this.closeEditLedger}
						afterSave={this.handleEditAfterSave}
						hideSave={!this.state.editCanSave}
						hideGoTo={true}
						size="lg"
						project={'pos'}
					/>
				</CardContent>
			</Card>
		)
	}
}
export default Framework.Components.withRootState(RegisterLedgers);
